import React from 'react';
import trackEvent from 'services/AnalyticsService';
import styles from './OtherProductsTile.module.scss'

const OtherProductsTile = () => {
  const onClick = () => {
    trackEvent('MyRAC_Login_InsurancePage');
  };

  return (
    <div className={styles.tileContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Other RAC products</p>
      </div>
      <div className={styles.body}>
        <p>Need another type of insurance?</p>
        <p>Visit our <a className={styles.link} onClick={onClick} href="https://www.rac.co.uk/insurance">Insurance page</a></p>
      </div>
    </div>
  );
}

export default OtherProductsTile;
